import { RouteConfig } from 'vue-router';

import RouterView from '@/components/layout/Router.vue';
import { teamRoute } from './teams/team.route';
import { teamsRoute } from './teams/teams.route';

export const teamsContainerRoute: RouteConfig = {
  path: 'teams',
  component: RouterView,
  children: [teamsRoute, teamRoute],
  meta: { authorized: true },
  redirect: { name: 'teams' }
};
